"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Parser_1 = require("../Parser");
var ScienceHeader = function (_a) {
    var header = _a.header;
    return (0, preact_1.h)("p", { class: "science-header" }, (0, Parser_1.parse)(header));
};
exports.default = ScienceHeader;
